import * as $ from "jquery";
import { Grid } from 'ag-grid-community';

export default class PricesComponent {
    constructor() {
        this.componentSelector = "#ecom-prices";
        this.grid = null;
        this.instance = this;
    }

    init() {
        let instance = this;
        if ($(instance.componentSelector).length > 0) {
            instance.bind();
        }
    }

    bind() {
        let instance = this;
        $('#js-prices-search').off().on('click', function () {
            instance.search(instance);
        });

        $('#js-reload-pricecache').off().on('click', function () {
            instance.reloadPriceCache(instance);
        });

        $('.js-upload-discounts').off().on('click', function () {
            $('#discounts-upload').addClass('locked');
            instance.upload();
        });
    }

    upload() {
        var uploadModel = {};
        uploadModel.Files = [];
        var marketId = $('#customermarket').val();

        var files = $('.dropzone .dz-filename span');
        $.each(files, function () {
            var file = {};
            file.FileName = $(this).html();
            uploadModel.Files.push(file);
        });

        axios({
            method: 'post',
            url: "/uploadexcel/savediscounts",
            data: { files: uploadModel, marketId: marketId }
        }).then(function (response) {
            $('#discounts-upload').removeClass('locked');
            var result = response.data;
            if (result.Failed == 0) {
                bootbox.alert("Filen är inläst, alla " + result.Imported + " rabattrader importerades.");
            }
            else {
                bootbox.alert("Filen är inläst, " + result.Imported + " rabattrader importerades korrekt. " + result.Failed + " rader kunde inte importeras. (" + result.FailedRows + ").");
            }
        }).catch(function (response) {
            console.log(response);
        });

    }

    search(instance) {
        let market = $('#customermarket').val();
        let customer = $('#customernumber').val();
        let sku = $('#articlenumber').val();

        if (sku == "") {
            bootbox.alert("Du måste ange ett artikelnummer.");
            return;
        }

        axios({
            method: 'post',
            url: "/pricelist/prices",
            data: { market: market, customer: customer, sku: sku }
        }).then(function (response) {
            console.log(JSON.parse(response.data));
            instance.render(instance, JSON.parse(response.data));
        }).catch(function (response) {
            bootbox.alert("Inga priser matchade sökningen.");
        });
    }

    currencyFormatter(params) {
        return new Intl.NumberFormat('sv-SE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(params.value);
    };

    render(instance, data) {

        if (instance.grid == null) {
            instance.grid = {
                columnDefs: [
                    { headerName: 'Marknad', field: 'Market' },
                    { headerName: 'Kund', field: 'CustomerCode' },
                    { headerName: 'Artikel', field: 'Sku' },
                    { headerName: 'Listpris ink moms', field: 'PriceIncVat', type: 'rightAligned', valueFormatter: instance.currencyFormatter },
                    { headerName: 'Listpris ex moms', field: 'PriceExVat', type: 'rightAligned', valueFormatter: instance.currencyFormatter },
                    { headerName: 'Varumärke', field: 'Brand' },
                    { headerName: 'Varumärkesrabatt (%)', field: 'CustomerDiscount', type: 'rightAligned' },
                    { headerName: 'Kundpris ink moms', field: 'CustomerPriceIncVat', type: 'rightAligned', valueFormatter: instance.currencyFormatter },
                    { headerName: 'Kundpris ex moms', field: 'CustomerPriceExVat', type: 'rightAligned', valueFormatter: instance.currencyFormatter },
                    { headerName: 'Moms (%)', field: 'Vat', type: 'rightAligned' },
                ],
                rowData: data,
                defaultColDef: { sortable: true, filter: true },
                domLayout: 'autoHeight'
            };

            var eGridDiv = document.querySelector('#report');
            new Grid(eGridDiv, instance.grid);
        }
        else {
            instance.grid.api.setRowData(data);
        }

    }

    reloadPriceCache(instance) {
        axios({
            method: 'post',
            url: "/pricelist/reloadpricecache"
        }).then(function (response) {
            bootbox.alert("Omläsning klar!")
        }).catch(function (response) {
            console.log(response)
        });
    }
}